// extracted by mini-css-extract-plugin
module.exports = {"social":"socials-module--social--8cL7z"};